import { ITelemetryItem } from '@microsoft/applicationinsights-web';

/** URLs can contain CRM/payment references even on automatically collected telemetry. */
export function sanitizeTelemetryUrl(value: string) {
  return value.split(/[?#]/, 1)[0]
    .replace(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/gi, ':id');
}

export function sanitizeTelemetry(item: ITelemetryItem) {
  const data = item.baseData;
  if (!data) return;
  for (const key of ['uri', 'url', 'refUri']) {
    if (typeof data[key] === 'string') data[key] = sanitizeTelemetryUrl(data[key]);
  }
  if ((item.baseType === 'PageviewData' || item.baseType === 'PageviewPerformanceData')
    && typeof data.name === 'string') data.name = sanitizeTelemetryUrl(data.name);
  if (item.ext?.trace?.name) item.ext.trace.name = sanitizeTelemetryUrl(item.ext.trace.name);
  const tags = item.tags as Record<string, string> | undefined;
  if (tags?.['ai.operation.name']) tags['ai.operation.name'] = sanitizeTelemetryUrl(tags['ai.operation.name']);
  if (item.baseType === 'RemoteDependencyData') {
    for (const key of ['data', 'name', 'target']) {
      if (typeof data[key] === 'string') data[key] = sanitizeTelemetryUrl(data[key]);
    }
  }
  if (data.properties) {
    for (const key of ['refUri', 'url', 'uri']) {
      if (typeof data.properties[key] === 'string') {
        data.properties[key] = sanitizeTelemetryUrl(data.properties[key]);
      }
    }
  }
  if (/^\/(pcsenrolment|pcsreenrolment|pcs-enrolment-payment-success|prepaid-payment-success)(\/|$)/i
    .test(window.location.pathname) && item.baseType === 'ExceptionData') {
    // Automatic JS errors can embed user input or a provider URL in their message/stack.
    data.exceptions = (data.exceptions || []).map((exception: { typeName?: string }) => ({
      typeName: exception.typeName, message: 'PCS enrolment client exception (details redacted)',
      hasFullStack: false, stack: '', parsedStack: []
    }));
    data.properties = { feature: 'pcsEnrolment', detailsRedacted: 'true' };
  }
}
